import { render } from "./PageNotFound.vue?vue&type=template&id=e9ffd15a"
const script = {}
script.render = render

export default script